import { isMobile } from "react-device-detect";
import { AppRouter } from "../../routers/AppRouter";
import { Header } from "./Header";
import { Container } from "react-bootstrap";

export const ContentPage = () => {
  return (
    <Container className="content-page">
      {!isMobile && <Header />}
      <AppRouter />
    </Container>
  );
};
